import React from 'react';

import { InterestFreeBottomInfo } from '../components/interest/InterestFreeBottomInfo';
import { PaymentBenefit } from '../components/payment/PaymentBenefit';
import { usePaymentService } from '../services/usePaymentService';

export const PaymentContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = usePaymentService();
  if (service.isHide) {
    return null;
  }

  return (
    <PaymentBenefit
      paymentEventList={service.paymentEventList}
      paymentEventNotificationList={service.paymentEventNotificationList}
      higherDiscountAmount={service.higherDiscountAmount}
      eventNameList={service.eventNameList}
      isOverExposureEventLimit={service.isOverExposureEventLimit}
      openInterestFeeSheet={() => service.openInterestFeeSheet(<InterestFreeBottomInfo />)}
      openPaymentBottomSheet={service.handlePaymentBottomSheetOpen}
    />
  );
};
